module.exports = __webpack_public_path__ + "static/media/johnson-wang-515975-unsplash.a1a2e211.jpg";